<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    :title="`${activeId ? '编辑' : '新增'}检测依据`"
    width="600px"
    height="450px"
    append-to-body
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item label="关联文件" prop="fileList" ref="fileFormItem">
            <UploadButton
              v-model="editForm.fileList"
              :limit="1"
              :fileType="['doc', 'docx', 'pdf', 'PDF']"
              :paramsData="{ type: 'upt_basis' }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="标准号" prop="basisCode">
            <el-input v-model.trim="editForm.basisCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测依据名称" prop="basisName">
            <el-input type="textarea" v-model="editForm.basisName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="排序" prop="remark">
            <el-input-number v-model="editForm.remark" :min="1" label="排序"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import UploadButton from '@/components/UploadArea/UploadButton';

import { getBasis, editBasis } from '@/api/system';

export default {
  components: { UploadButton },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      detailLoading: false,
      editForm: { fileList: [], basisCode: '', basisName: '' },
      rules: {
        basisCode: [{ required: true, message: '请输入检标准号', trigger: 'blur' }],
        basisName: [{ required: true, message: '请输入样品名称检测依据名称', trigger: 'blur' }]
      },
      fileInit: true,
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.fileInit = false;
        this.getDetailData();
      }
    },
    'editForm.fileList': {
      handler(val) {
        if (val.length && this.fileInit) {
          const fileName = val[0].fileName;
          const dotIndex = fileName.lastIndexOf('.');
          this.editForm.basisName = dotIndex > 0 ? fileName.substring(0, dotIndex) : fileName;
        }
      },
      deep: true
    }
  },
  methods: {
    async getDetailData() {
      this.detailLoading = true;
      try {
        const { data } = await getBasis({ id: this.activeId });
        this.editForm = {
          id: data.id,
          basisCode: data.basisCode,
          basisName: data.basisName,
          remark: data.remark
        };

        if (data.fileId) {
          this.editForm.fileList = [{ fileName: data.fileName, filePath: data.filePath, fileId: data.fileId }];
        }
      } finally {
        this.detailLoading = false;
      }
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          const fileId = this.editForm.fileList?.[0]?.fileId ?? null;
          const params = {
            id: this.editForm.id ?? null,
            basisCode: this.editForm.basisCode,
            basisName: this.editForm.basisName,
            remark: this.editForm.remark,
            fileId
          };

          try {
            await editBasis(params);

            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
